// extracted by mini-css-extract-plugin
export default {"container":"wvkMuGvg044PswpwyHd3","content":"sbxPoHZf8rDpV9Qu2Ngy"};